export const getLocation = () => {
  const metaTag = document.querySelector('meta[name="leaderos-location"]');
  return metaTag ? metaTag.getAttribute('content') : null;
};

export const saveSnapshot = async (step, state) => {
  // Save the current state to the local storage
  const snapshot = { step, state };
  localStorage.setItem('snapshot', JSON.stringify(snapshot));
}

export const loadSnapshot = () => {
  // Load the snapshot from the local storage
  const snapshot = localStorage.getItem('snapshot');
  return snapshot ? JSON.parse(snapshot) : null;
}

export const clearSnapshot = () => {
  // Clear the snapshot from the local storage
  localStorage.removeItem('snapshot');
}